<template>
  <div class="section showcase">
        
        <div id="top-block">
          <showcase-title v-for="showcase in showcases" :key="showcase.id" :showcase="showcase" :pageId="pageNum"></showcase-title> 
        </div>
        
        <div class="button-wrapper">
            <button @click="decrease"><img class="chefron" :src="require(`@/static/img/chefron.svg`)"/></button>
            <p class="pageNumber">{{ pageNum + 1 }}&nbsp;<span>|</span>&nbsp;{{ showcases.length }}</p>
            <button @click="increase"><img class="chefron flipped" :src="require(`@/static/img/chefron.svg`)"/></button>
        </div>

        <div id="bottom-block">
          <showcase-info v-for="showcase in showcases" :key="showcase.id" :showcaseInfo="showcase" :pageId="pageNum"></showcase-info> 
        </div>
  </div>
</template>

<style lang="scss">
</style>

<script>
import ShowcaseSlider from '@/components/showcaseSlider'; 
import ShowcaseInfo from '@/components/showcaseInfo';
import { TimelineMax } from '@/vendor';

export default {
  name: 'Home',

  components: {
    'showcase-title': ShowcaseSlider,
    'showcase-info': ShowcaseInfo
  },

  data() 
  {
    return {
      pageNum: 0,
      showcases: [
        {
          id: 0,
          title: 'FIELDLABS',
          type: 'FRONTEND',
          publisher: '',
          tech: 'Vue.js, HTML, (S)CSS, JS, GSAP',
          summary: 'A single page website campaign to highlight the newest Field-Lab building. My main responsibilities were to set up the entire project, layout all the elements responsively, add in video elements displayed on the main floor, randomly spawn and animate the clouds in the background and style the bullet points.',
          img: 'field-labs.jpg',
          route: 'https://www.field-lab.nl/'
        },
        {
          id: 1,
          title: 'LOTTO GOUDENBAL',
          type: 'FRONTEND',
          publisher: '',
          tech: 'Vue.js, HTML, (S)CSS, JS, GSAP',
          summary: 'This website was created to promote the Golden ball lottery campaign. My main tasks were to animate the main slot machine, style the home page responsively and add in page transition effects.',
          img: 'lotto.jpg',
          route: 'https://goudenbal.accept-env.com/'
        },
        {
          id: 2,
          title: 'T MOBILE',
          type: 'BANNERS',
          publisher: ' - WEBORAMA',
          tech: 'HTML, (S)CSS, JS, ffmpeg, GSAP, Gulp',
          summary: "This Home Page Takeover video campaign banner from T-Mobile highlights my expertise in video conversion. In order to reduce the file size, I compressed each video in ffmpeg conforming this rich media ad to Weborama's specifications.",
          img: 'tmobile.jpg',
          route: 'https://clients.weborama.nl/files/campaigns2/2151735882/197937/default.htm'
        },
        {
          id: 3,
          title: '2K40',
          type: 'BANNERS',
          publisher: ' - DCM',
          tech: 'HTML, (S)CSS, JS, GSAP, Gulp',
          summary: 'An artistic and creative banner set created to promote radio channel 2K40. All the elements were designed in HTML and css and animated in GSAP.',
          img: '2k40.jpg',
          route: 'http://preview.bann.rs/20WEF002TKF-2k40/'
        },
        {
          id: 4,
          title: 'WE FASHION',
          type: 'BANNERS',
          publisher: ' - ADFORMS',
          tech: 'HTML, (S)CSS, JS, GSAP, Gulp',
          summary: 'A seasonal promotional campaign for retail brand WeFashion. My expertise in compositing helped to achieve the illusion of the kids actively moving in 3D space. This was achieved by cutting out individual elements in Photoshop and then placing and animating them using the tech languages listed above.',
          img: 'weFashion.jpg',
          route: 'http://preview.bann.rs/18BWR005WEF-we/'
        },
        {
          id: 5,
          title: 'PATHÉ',
          type: 'BANNERS',
          publisher: ' - DCM',
          tech: 'HTML, (S)CSS, JS, GSAP, Gulp',
          summary: 'A promotional campaign for Pathe the theatre company. The most notable achievement in this campaign is the use of CSS shadows to create a 3D look on the main text.',
          img: 'pathe.jpg',
          route: 'http://preview.bann.rs/20DEP003PAT-pathe/'
        },
        {
          id: 6,
          title: 'JUMBO',
          type: 'BANNERS',
          publisher: ' - DCM',
          tech: 'HTML, (S)CSS, JS, GSAP, Gulp',
          summary: 'A promotional campaign for the Dutch Grand Prix in conjunction with supermarket corporation Jumbo. In order to get the feeling of the car moving quickly through the scene, I animated the various motion blurs sporadically as well as a camera shake in one of the scenes.',
          img: 'jumbo.jpg',
          route: 'http://preview.bann.rs/20YUN001JUM-jumbo/'
        }
      ]
    };
  },

  mounted()
  {
    this.animateShowcaseIn();
  },

  methods:{
    increase()
    {
      this.pageNum = (this.pageNum + 1) % this.showcases.length;
    },

    decrease()
    {
      this.pageNum = this.pageNum === 0 ? this.showcases.length - 1 : this.pageNum - 1
    },

    animateShowcaseIn()
    {
      let tl = new TimelineMax({ });

      tl.from('.showcase .button-wrapper', 0.5, { autoAlpha: 0 }, 1);
    }
  }
}
</script>
